<template>
  <button @click="exportTransaction" class="btn btn-info btn-sm">
    <i class="fa fa-download"></i>
    {{ $t('export') }}
    <b-modal v-model="exporting" :title="$t('exportingData')" @close="close" no-close-on-esc no-close-on-backdrop
             no-enforce-focus>
      <b-progress :max="totalCount">
        <b-progress-bar :value="downloadedCount"
                        :label="`${((downloadedCount / totalCount) * 100).toFixed(0)}%`"></b-progress-bar>
      </b-progress>
    </b-modal>
  </button>
</template>


<script>
import {saveAs} from 'file-saver';
import Excel from 'exceljs';

export default {
  name: "CallHistoryExport",
  props: ['filter', 'totalCount'],
  data() {
    return {
      service: '/phone-number',
      exporting: false,
      cancelRequest: false,
      downloadedCount: 0
    }
  },
  methods: {
    exportTransaction: async function () {
      this.downloadedCount = 0;
      this.exporting = true;
      let workbook = new Excel.Workbook();
      let sheet = workbook.addWorksheet('data');
      this.setupSheet(sheet);

      let response = null;
      let params = Object.assign({}, this.filter);
      params.page = 1;
      params.pageSize = 500;
      do {
        if (this.cancelRequest) {
          break;
        }
        let result = await this.$service.get(this.service, {
          params: params
        });
        params.page += 1;
        response = result.data;
        response.docs.forEach(item => {
          let row = {
            phoneNumber: item.number,
            client: item.client ? item.client.domain : null,
            network: item.network ? item.network.name : null,
            hostType: item.host ? item.host.type : null,
            desc: item.desc,
            gateway: item.gateway ? item.gateway.name : null,
            proxy: item.gateway ? item.gateway.proxy : null,
            privateFee: item.privateFee ? this.$t('yes') : this.$t('no'),
            setupFee: item.privateFee ? item.setupFee : item.network.setupFee,
            monthlyFee: item.privateFee ? item.monthlyFee : item.network.monthlyFee,
            netCallFee: item.privateFee ? item.netCallFee : item.network.netCallFee,
            offnetCallFee: item.privateFee ? item.offnetCallFee : item.network.offnetCallFee,
            brandNameSetupFee: item.isBrandName ? item.brandNameSetupFee : '',
            brandNameHotlineSetupFee: item.isBrandName ? item.brandNameHotlineSetupFee : '',
            brandNameMonthlyFee: item.isBrandName ? item.brandNameMonthlyFee : '',
            inboundCallFee: item.isInboundCharge ? item.inboundCallFee : ''
          }
          if(row.hostType && row.hostType === 'single') {
            row.host = item.host.ip;
          } else if(row.hostType && row.hostType === 'cluster') {
            row.host = item.host.routingNodes ? item.host.routingNodes.find(n => n.default).publicIp : null;
            row.ipBackup = item.host.routingNodes && item.host.routingNodes.length ? item.host.routingNodes.filter(n => !n.default).map(i => i.publicIp).join(', ') : null;
          }
          sheet.addRow(row);
          this.downloadedCount += 1;
        });
      } while (response && response.hasNextPage);

      workbook.xlsx.writeBuffer({base64: true}).then(data => {
        this.exporting = false;
        saveAs(new Blob([data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}),
            'callio-admin-number.xlsx');
      }).finally(() => {
        this.cancelRequest = false;
        this.downloadedCount = 0;
      });
    },
    setupSheet: function (sheet) {
      sheet.columns = [
        {header: this.$t('phoneNumber'), key: 'phoneNumber', width: 15},
        {header: this.$t('network'), key: 'network', width: 20},
        {header: this.$t('hostType'), key: 'hostType', width: 25},
        {header: this.$t('host'), key: 'host', width: 25},
        {header: this.$t('ipBackup'), key: 'ipBackup', width: 25},
        {header: this.$t('desc'), key: 'desc', width: 15},
        {header: this.$t('gateway'), key: 'gateway', width: 15},
        {header: this.$t('proxy'), key: 'proxy', width: 15},
        {header: this.$t('client'), key: 'client', width: 25},
        {header: this.$t('privateFee'), key: 'privateFee', width: 25},
        {header: this.$t('setupFee'), key: 'setupFee', width: 25},
        {header: this.$t('monthlyFee'), key: 'monthlyFee', width: 25},
        {header: this.$t('netCallFee'), key: 'netCallFee', width: 25},
        {header: this.$t('offnetCallFee'), key: 'offnetCallFee', width: 25},
        {header: this.$t('brandNameSetupFee'), key: 'brandNameSetupFee', width: 25},
        {header: this.$t('brandNameHotlineSetupFee'), key: 'brandNameHotlineSetupFee', width: 25},
        {header: this.$t('brandNameMonthlyFee'), key: 'brandNameMonthlyFee', width: 25},
        {header: this.$t('inboundCallFee'), key: 'inboundCallFee', width: 25},
      ];
    },
    close() {
      this.cancelRequest = true;
    }
  },
  i18n: {
    messages: {
      en: {
        privateFee: "Private fee",
        setupFee: 'Setup fee',
        monthlyFee: 'Monthly fee',
        netCallFee: 'In network call fee',
        offnetCallFee: 'Off network call fee',
        yes: 'Yes',
        no: 'No',
        inboundCallFee: "Inbound Call Fee",
        fixedCallFee: "Fixed/call charges",
        brandNameSetupFee: "Brand name registration fee",
        brandNameHotlineSetupFee: "Fee for assigning identification brand name to hotline",
        brandNameMonthlyFee: "Identification brand name maintenance fee/Month"
      },
      vi: {
        privateFee: "Bảng phí riêng",
        setupFee: 'Phí cài đặt',
        monthlyFee: 'Phí hàng tháng',
        netCallFee: 'Phí gọi nội mạng',
        offnetCallFee: 'Phí gọi ngoại mạng',
        yes: 'Có',
        no: 'Không',
        inboundCallFee: "Phí gọi vào",
        fixedCallFee: "Thu phí cố định/ cuộc gọi",
        brandNameSetupFee: "Phí đăng ký tên định danh",
        brandNameHotlineSetupFee: "Phí gán tên định danh vào hotline",
        brandNameMonthlyFee: "Phí duy trì tên định danh/Tháng"
      }
    }
  }
}
</script>